"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceConfigurationManager = void 0;
const Exceptions_1 = require("../../core/Exceptions");
const BluetoothLEProtocolConfiguration_1 = require("./BluetoothLEProtocolConfiguration");
const SerialProtocolConfiguration_1 = require("./SerialProtocolConfiguration");
const HIDProtocolConfiguration_1 = require("./HIDProtocolConfiguration");
const Lovense_1 = require("../protocols/Lovense");
const WeVibe_1 = require("../protocols/WeVibe");
const VorzeA10Cyclone_1 = require("../protocols/VorzeA10Cyclone");
const MagicMotion_1 = require("../protocols/MagicMotion");
const LiBo_1 = require("../protocols/LiBo");
const Youcups_1 = require("../protocols/Youcups");
const Maxpro_1 = require("../protocols/Maxpro");
const FleshlightLaunch_1 = require("../protocols/FleshlightLaunch");
const KiirooGen2Vibe_1 = require("../protocols/KiirooGen2Vibe");
const defaultDeviceConfig = __importStar(require("../../../dependencies/buttplug-device-config/buttplug-device-config.json"));
const Youou_1 = require("../protocols/Youou");
const KiirooGen21_1 = require("../protocols/KiirooGen21");
const Motorbunny_1 = require("../protocols/Motorbunny");
class DeviceConfigurationManager {
    constructor(aConfigObject) {
        this._configObject = {};
        this._configs = new Map();
        this._protocols = new Map();
        this._configObject = aConfigObject;
        this._protocols.set("lovense", Lovense_1.Lovense);
        this._protocols.set("wevibe", WeVibe_1.WeVibe);
        this._protocols.set("vorze-sa", VorzeA10Cyclone_1.VorzeA10Cyclone);
        this._protocols.set("magic-motion", MagicMotion_1.MagicMotion);
        this._protocols.set("maxpro", Maxpro_1.Maxpro);
        this._protocols.set("kiiroo-v2", FleshlightLaunch_1.FleshlightLaunch);
        this._protocols.set("kiiroo-v21", KiirooGen21_1.KiirooGen21);
        this._protocols.set("kiiroo-v2-vibrator", KiirooGen2Vibe_1.KiirooGen2Vibe);
        this._protocols.set("youou", Youou_1.Youou);
        this._protocols.set("youcups", Youcups_1.Youcups);
        this._protocols.set("libo", LiBo_1.LiBo);
        this._protocols.set("motorbunny", Motorbunny_1.Motorbunny);
        // Parse our configuration object last, as we need to add device protocols
        // first.
        this.ParseConfig();
    }
    static get Manager() {
        if (DeviceConfigurationManager._manager === null) {
            throw new Exceptions_1.ButtplugDeviceException("Device configuration manager not yet initialized!");
        }
        return DeviceConfigurationManager._manager;
    }
    static LoadFromInternalConfig() {
        DeviceConfigurationManager._manager = new DeviceConfigurationManager(defaultDeviceConfig);
    }
    static LoadFromJsonExternalConfig(aExternalConfig) {
        const config = JSON.parse(aExternalConfig);
        DeviceConfigurationManager._manager = new DeviceConfigurationManager(config);
    }
    static LoadFromWebConfig(aUrl = "https://buttplug-device-config.buttplug.io") {
        return __awaiter(this, void 0, void 0, function* () {
            const config = yield fetch(aUrl);
            DeviceConfigurationManager.LoadFromJsonExternalConfig(yield config.text());
        });
    }
    LoadUserConfiguration() {
        // TODO Fill in user config
    }
    GetAllConfigsOfType(constructor) {
        const configs = [];
        for (const [name, config] of this._configs.entries()) {
            if (config instanceof constructor) {
                configs.push(config);
            }
        }
        return configs;
    }
    Find(aConfig) {
        for (const [name, config] of this._configs.entries()) {
            if (config.Matches(aConfig)) {
                return [config, this._protocols.get(name)];
            }
        }
        return undefined;
    }
    ParseConfig() {
        this._configs = new Map();
        const protocols = this._configObject.protocols;
        for (const protocolName of Object.keys(protocols)) {
            // If we don't support the protocol, don't load it.
            if (!this._protocols.has(protocolName)) {
                // TODO We should log here.
                continue;
            }
            const protocol = protocols[protocolName];
            // Ok maybe XInput being null isn't such a good idea.
            if (protocol == null) {
                continue;
            }
            for (const bus of Object.keys(protocol)) {
                switch (bus) {
                    case "btle":
                        this._configs.set(protocolName, BluetoothLEProtocolConfiguration_1.BluetoothLEProtocolConfiguration.ConstructFromObject(protocol[bus]));
                        break;
                    case "serial":
                        this._configs.set(protocolName, new SerialProtocolConfiguration_1.SerialProtocolConfiguration(protocol[bus]));
                        break;
                    case "hid":
                        this._configs.set(protocolName, new HIDProtocolConfiguration_1.HIDProtocolConfiguration(protocol[bus]));
                        break;
                }
            }
        }
    }
}
exports.DeviceConfigurationManager = DeviceConfigurationManager;
DeviceConfigurationManager._manager = null;
//# sourceMappingURL=DeviceConfigurationManager.js.map